var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMattress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6 5H18A4 4 0 0 1 22 9V17A2 2 0 0 1 20 19H4A2 2 0 0 1 2 17V9A4 4 0 0 1 6 5M5 9A1 1 0 1 0 7 9A1 1 0 0 0 5 9M11 9A1 1 0 1 0 13 9A1 1 0 0 0 11 9M17 9A1 1 0 1 0 19 9A1 1 0 0 0 17 9M4 14V17H20V14H4Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMattress);
export default __webpack_public_path__ + "static/media/mattress.e5522758e5ad73f4a0f5a34b9cd6ccb3.svg";
export { ForwardRef as ReactComponent };